module.exports = __webpack_public_path__ + "img/redtea_logo_en.f53767cc.png";